import React, { Fragment } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper';
import './Testimonials.css';
import TestimonialData from './TestimonialData';

const Testimonials = () => {
    return (
        <div>
            <section className="testimonial-section bg-color-1 centred" style={{ padding: '80px 0', backgroundColor: '#f9f9f9', position: 'relative' }}>
                <div style={{
                    position: 'absolute',
                    top: '10%',
                    left: '5%',
                    fontSize: '300px',
                    color: 'rgba(37, 181, 121, 0.05)',
                    fontFamily: 'serif',
                    lineHeight: 1,
                    zIndex: 0,
                    pointerEvents: 'none'
                }}>
                    "
                </div>

                <div className="auto-container" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="sec-title" style={{ marginBottom: '50px' }}>
                        <h5 style={{ color: '#25b579', fontWeight: '700', fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '15px' }}>
                            CLIENT FEEDBACK
                        </h5>
                        <h2 style={{ color: '#0a3d62', fontSize: 'clamp(2.5rem, 4vw, 3.5rem)', fontWeight: '300', margin: 0 }}>
                            What our clients <strong style={{ fontWeight: '700' }}>say about us</strong>
                        </h2>
                    </div>
                </div>

                <div className="auto-container" style={{ position: 'relative', zIndex: 1 }}>
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        navigation={true}
                        loop={true}
                        modules={[Autoplay, Pagination, Navigation]}
                        className="testimonials-custom-bg"
                        style={{ paddingBottom: '50px' }}
                    >
                        {TestimonialData.map((i) => {
                            return (
                                <Fragment key={i?.id}>
                                    <SwiperSlide>
                                        <div className="testimonial-block-one" style={{ maxWidth: '800px', margin: '0 auto' }}>
                                            <div className="inner-box" style={{ 
                                                backgroundColor: '#ffffff', 
                                                boxShadow: '0 20px 40px rgba(0,0,0,0.05)',
                                                padding: '40px',
                                                borderRadius: '12px',
                                                border: '1px solid rgba(0,0,0,0.02)',
                                                position: 'relative'
                                            }}>
                                                <figure className="thumb-box" style={{ 
                                                    border: '4px solid #fff', 
                                                    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                                                    marginTop: '-80px', // Pull it up
                                                    marginBottom: '30px'
                                                }}>
                                                    <img src={i?.thumbimage} key={i?.thumbimage} alt={i?.testimonialName} />
                                                </figure>
                                                <div className="text" style={{ fontStyle: 'italic', color: '#555555', fontSize: '1.25rem', lineHeight: '1.8' }}>
                                                    <p key={i.desc}>"{i.desc}"</p>
                                                </div>
                                                <div className="author-info" style={{ marginTop: '30px' }}>
                                                    <h4 key={i?.testimonialName} style={{ color: '#0a3d62', fontWeight: '700', fontSize: '1.2rem', marginBottom: '5px' }}>{i?.testimonialName}</h4>
                                                    <span className="designation" key={i?.designation} style={{ color: '#25b579', fontWeight: '600', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                        {i?.designation}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Fragment>
                            );
                        })}
                    </Swiper>
                </div>
            </section>
        </div>
    );
};

export default Testimonials;
